import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=111b9440&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('111b9440')) {
      api.createRecord('111b9440', component.options)
    } else {
      api.reload('111b9440', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=111b9440&", function () {
      api.rerender('111b9440', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2luJhc2Dxt8VE/JS/pricehelp.vue"
export default component.exports